import { useEffect, useState } from "react";

export const useConversationTimer = ( initialSeconds, onComplete ) => {
  const [timeLeft, setTimeLeft] = useState(initialSeconds);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (!started) return;

    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onComplete();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [started]);

  return {
    timeLeft,
    start: () => setStarted(true),
    started
  };
};
